import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("cl_lang") || "tr");
  useEffect(() => {
    localStorage.setItem("cl_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
};
